import { Img } from 'components';
import React, { useState } from 'react';
import { Text } from 'styles';
import * as S from './ProductStyle';

// 설치/운용 지역 인터랙티브 지도
//  - 핀 클릭 → 옆 패널에 해당 지역 설치 사진 표시
//  - 한 지역에 농장이 여러 곳이면 groups(농장) 탭으로 전환
//  - 사진이 여러 장이면 하단 썸네일로 전환
export function LocationMap({ data }) {
  const [active, setActive] = useState(0);
  const [group, setGroup] = useState(0);
  const [photo, setPhoto] = useState(0);

  const pin = data.pins[active];
  // groups가 있으면 농장별 그룹, 없으면 imgs 하나를 단일 그룹으로 취급
  const groups = pin.groups || [{ label: null, imgs: pin.imgs || [] }];
  const g = groups[Math.min(group, groups.length - 1)];
  const imgs = g.imgs || [];
  const current = imgs[Math.min(photo, imgs.length - 1)];

  const selectPin = (i) => {
    setActive(i);
    setGroup(0);
    setPhoto(0);
  };
  const selectGroup = (i) => {
    setGroup(i);
    setPhoto(0);
  };

  return (
    <S.MapWrap>
      <S.MapCanvas>
        <img src={data.base} alt="설치·운용 지역 지도" />
        {data.pins.map((p, i) => (
          <S.Pin
            key={`${p.name}_${i}`}
            type="button"
            $active={i === active}
            style={{ left: `${p.x}%`, top: `${p.y}%` }}
            onClick={() => selectPin(i)}
            aria-label={`${p.name} 설치 현장 보기`}
          >
            <span className="dot" />
            <span className="label">{p.name}</span>
          </S.Pin>
        ))}
      </S.MapCanvas>

      <S.MapPhoto>
        <S.MapPhotoImgBox key={`${pin.name}_${group}_${photo}`}>
          <Img src={current} $height="100%" $objectFit="cover" />
        </S.MapPhotoImgBox>

        <S.MapPhotoCaption>
          <Text $type="h6" $mType="h7">
            {pin.name}
            {g.label ? ` · ${g.label}` : ''} 설치 현장
          </Text>
          {imgs.length > 1 && (
            <Text $type="b7" $mType="b8" $color="primary">
              {photo + 1} / {imgs.length}
            </Text>
          )}
        </S.MapPhotoCaption>

        {groups.length > 1 && (
          <S.GroupTabs>
            {groups.map((gr, i) => (
              <S.GroupTab
                key={`${pin.name}_group_${i}`}
                type="button"
                $active={i === group}
                onClick={() => selectGroup(i)}
              >
                {gr.label || `농장 ${i + 1}`}
              </S.GroupTab>
            ))}
          </S.GroupTabs>
        )}

        {imgs.length > 1 && (
          <S.ThumbRow>
            {imgs.map((src, i) => (
              <S.Thumb
                key={`${pin.name}_${group}_thumb_${i}`}
                type="button"
                $active={i === photo}
                onClick={() => setPhoto(i)}
                aria-label={`사진 ${i + 1}`}
              >
                <img src={src} alt={`${pin.name} ${i + 1}`} />
              </S.Thumb>
            ))}
          </S.ThumbRow>
        )}
      </S.MapPhoto>
    </S.MapWrap>
  );
}
